import React, { useEffect, useState } from 'react';
import classnames from 'classnames';

import callApi from '../../../utils/callApi';
import { FEATURED_LIST_ALL } from '../../../constants/apiUrls/apiUrls';
import FeaturedItem from '../../../components/featuredComponents/FeaturedItem';
import SubscribeCTAButtonV2 from '../../../components/GuestHomePageComponents/V2Components/SubscribeCTAButtonV2';

import styles from './css/GuestHomePageV2.module.css';


function NewFeatures() {
  const [featuredList, setFeaturedList] = useState([]);

  useEffect(() => {
    callApi(FEATURED_LIST_ALL.replace('{page}', 0).replace('{size}', 9)).then(
      (data) => {
        setFeaturedList(data?.data || []);
      }
    );
  }, []);

  return (
    <div
      className={classnames(
        styles.container,
        styles.anchorSection,
        styles.darkBackground
      )}
    >
      <h2 className={styles.header}>New Features</h2>
      <div className={styles.featuredGridContainer}>
        {featuredList.map((feature) => (
          <FeaturedItem key={feature.id} featuredItem={feature} styles={styles} />
        ))}
      </div>
      <div className={styles.buttonContainer}>
        <SubscribeCTAButtonV2
          doNotHide={true}
          link="/featured-content"
          title="VIEW ALL NEW FEATURES"
        />
      </div>
    </div>
  );
}

export default NewFeatures;
